const LiteDashboard = () => {

    return (
        <>
            Not implemented yet
        </>
    )
}

export default LiteDashboard;